import {
  HIDE_OFFER_DATA_LOADER,
  HIDE_OFFER_LOADER,
  HIDE_OFFER_TRACKER_LIST_LOADER,
  HIDE_OFFERS_WITH_REGULAR_MATCHING_LOADER,
  HIDE_TRACKERS_LOADER,
  OFFER_STATE_INIT,
  SET_ERROR_TRACKER_OFFER_PROFILE,
  SET_OFFER,
  SET_OFFER_DATA,
  SET_OFFER_HISTORY_ITEM,
  SET_OFFER_HISTORY_LIST,
  SET_OFFER_TRACKER_LIST,
  SET_OFFERS,
  SET_OFFERS_FOR_CLIENT,
  SET_OFFERS_WITH_REGULAR_MATCHING,
  SET_TRACKER_OFFER_PROFILE,
  SET_TRACKERS,
  SHOW_OFFER_DATA_LOADER,
  SHOW_OFFER_LOADER,
  SHOW_OFFER_TRACKER_LIST_LOADER,
  SHOW_OFFERS_WITH_REGULAR_MATCHING_LOADER,
  SHOW_TRACKERS_LOADER,
  SET_OFFERS_RENT_FOR_CLIENT,
  OFFERS_BY_CONTRACT_LOADER, SET_OFFERS_BY_CONTRACT
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  contractOffers: [],
  contractOffersLoader: false,
  dataClient: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  dataRentOffers: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  offers: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  // offers: {
  //   count: 0,
  //   next: null,
  //   previous: null,
  //   page: 1,
  //   sizePerPage: 10,
  //   results: [],
  // },
  dataTrackers: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  offer: null,
  trackers: [],
  historyData: [],
  history_item: null,
  profileTrackerData: [],
  is_trackers_error: false,
  loading_trackers: false,
  loading_trackers_list: false,
  offer_data: { currencies: [] },
  loading_offer_data: false,
  loading: false,
  loader_offer: false,
  // success: null,
  error: null,
  offers_with_regular_matching: [],
  is_loading_offers_with_regular_matching: false,
};

const Offers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_OFFERS_WITH_REGULAR_MATCHING:
      return {
        ...state,
        offers_with_regular_matching: action.payload
      }
    case SHOW_OFFERS_WITH_REGULAR_MATCHING_LOADER:
      return {
        ...state,
        is_loading_offers_with_regular_matching: true
      }
    case HIDE_OFFERS_WITH_REGULAR_MATCHING_LOADER:
      return {
        ...state,
        is_loading_offers_with_regular_matching: false
      }
    case SET_OFFER_HISTORY_ITEM:
      return {
        ...state,
        history_item: action.payload
      }
    case SET_OFFERS_FOR_CLIENT:
      return {
        ...state,
        dataClient: action.payload,
      };
    case SET_OFFERS_RENT_FOR_CLIENT: 
      return {
        ...state,
        dataRentOffers: action.payload,
      }
    case SET_OFFER:
      return {
        ...state,
        offer: action.payload,
      };
    case SET_TRACKERS:
      return {
        ...state,
        trackers: action.payload,
      };
    case SET_OFFERS:
      return {
        ...state,
        offers: action.payload,
      };
    case SHOW_TRACKERS_LOADER:
      return {
        ...state,
        loading_trackers: true,
      };
    case HIDE_TRACKERS_LOADER:
      return {
        ...state,
        loading_trackers: false,
      };
    case SHOW_OFFER_LOADER:
      return {
        ...state,
        loader_offer: true,
      };
    case HIDE_OFFER_LOADER:
      return {
        ...state,
        loader_offer: false,
      };
    case SET_OFFER_DATA:
      return {
        ...state,
        offer_data: action.payload,
      };
    case SHOW_OFFER_DATA_LOADER:
      return {
        ...state,
        loading_offer_data: true,
      };
    case HIDE_OFFER_DATA_LOADER:
      return {
        ...state,
        loading_offer_data: false,
      };
    case SET_OFFER_HISTORY_LIST:
      return {
        ...state,
        historyData: action.payload,
      };
    case SET_OFFER_TRACKER_LIST:
      return {
        ...state,
        dataTrackers: action.payload,
      };
    case SHOW_OFFER_TRACKER_LIST_LOADER:
      return {
        ...state,
        loading_trackers_list: true,
      };
    case HIDE_OFFER_TRACKER_LIST_LOADER:
      return {
        ...state,
        loading_trackers_list: false,
      };
    case SET_TRACKER_OFFER_PROFILE:
      return {
        ...state,
        profileTrackerData: action.payload,
      };
    case SET_ERROR_TRACKER_OFFER_PROFILE:
      return {
        ...state,
        is_trackers_error: action.payload,
      };
    case OFFERS_BY_CONTRACT_LOADER: 
      return {
        ...state,
        contractOffersLoader: !state.contractOffersLoader
      }
    case SET_OFFERS_BY_CONTRACT:
      return {
        ...state,
        contractOffers: action.payload
      }
    case OFFER_STATE_INIT:
      return {
        ...INIT_STATE,
      };
    default:
      return state;
  }
};

export default Offers;
